import { Theme } from '@material-ui/core';
import { CSSProperties } from 'react';

export const getPaperStyle = ({ spacing }: Theme): CSSProperties => ({
  marginTop: spacing(2),
});

export default {
  getPaperStyle,
};
